import UnitJson from './interfaces/UnitJson'

export default class Unit {
  name: string
  displayName: string

  constructor(name: string, displayName: string) {
    this.name = name
    this.displayName = displayName
  }

  static fromJson(data: UnitJson) {
    return new this(data.name, data.displayName)
  }
}
